<template>
    <v-container>
        <v-overlay v-model="overlay" color="white" opacity="1" persistent>
        <v-container style="text-align: center">
            
        <v-progress-circular
            :size="50"
            color="#234a98"
            indeterminate
        ></v-progress-circular>
        <p class="pt-2" style="font-size: 14px; color: #234a98">
            {{ $t('common.loading') }}
        </p>
        </v-container>
        </v-overlay>
        <v-layout style="justify-content: center;" align="center">
            <v-flex xs12 sm12>
                <img class="mt-16" src="../assets/YT_logo_png.png" style="height: 145px;" />
            </v-flex>
        </v-layout>
        <v-dialog persistent max-width="600" v-model="forgotPassword">
            <v-card>
                <v-card-title>{{ $t('login.resetPassword') }}</v-card-title>
                <v-card-text>
                    <p>{{ $t('login.resetPasswordInstructions') }}</p>
                    <v-text-field :label="$t('login.email')" v-model="email" outlined color="#213A8F"
                     />
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#213A8F" @click="forgotPassword = false">{{ $t('common.cancel') }}</v-btn>
                    <v-btn text color="#213A8F" @click="CheckAndSendResetEmail">{{ $t('common.confirm') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout style="justify-content: center;" class="text-xs-center">
            <v-flex xs12 sm12 md12>
                <div style="display: flex; align-items: center; justify-content: center; " align="center" class="my-5">  
                    <v-card style="max-width: 800px; v-align:center;" >
                        <v-card-text >
                            <v-form>
                                <v-text-field color="#213A8F" class="text_youtissue" v-model="username" filled :label="$t('login.username')" prepend-inner-icon="mdi-account" outlined/>
                                <v-text-field color="#213A8F" v-model="password" filled :label="$t('login.password')" prepend-inner-icon="mdi-lock"
                                            outlined :append-icon="value ? 'mdi-eye' : 'mdi-eye-off'" 
                                            @click:append=" () => (value = !value)" :type="value ? 'password' : 'text'" @keypress="CheckInvio()"/>
                                <v-btn color="#213A8F" @click="Login" dark block style="font-weight: bold;">{{ $t('login.button') }}</v-btn>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
        <!-- Sezione "Forgot Password?" temporaneamente commentata
        <v-layout style="justify-content: center;" class="text-xs-center">
            <v-btn text @click="forgotPassword = true;">Forgot Password?</v-btn>
        </v-layout>
        -->
        <v-snackbar
        v-model="snackbar"
        :timeout="timeout"
        color="red accent-2"
        >
        {{ $t('login.error') }}

            <template v-slot:action="{ attrs }">
                <v-btn
                color="blue"
                text
                v-bind="attrs"
                @click="snackbar = false"
                >
                {{ $t('login.close') }}
                </v-btn>
                <v-snackbar
                v-model="snackbarReset"
                color="green"
                ></v-snackbar>
            </template>
        </v-snackbar>
        <v-snackbar
        v-model="snackbarReset"
        color="green"
        >Reset email successfully sent.</v-snackbar>
    </v-container>
</template>

<script>
import axios from "axios";
import { normalizeTimezone } from '@/utils/dateTimezone';
export default {
    data() {
        return {
            forgotPassword: false,
            email: '',
            overlay: false,
            username : "",
            password : "",
            value: true,
            snackbar: false,
            snackbarReset: false,
            timeout: 5000
        }
    },
    methods: {
        /** Usa la normalizzazione centralizzata (nomi display → IANA, es. "Eastern European Time" → "Europe/Athens") */
        normalizeTimezone(value) {
            return normalizeTimezone(value);
        },
        CheckAndSendResetEmail(){
            this.snackbarReset = true;
        },
        CheckInvio(evt){
            evt = evt ? evt : window.event;
            var charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode === 13) {
                this.Login();
      }
        },
        Login(){
            this.overlay = true;
            axios.post(this.$store.state.BASE_URL + this.$store.state.URL_NEW_LOGIN,{
                "user": this.username,
                "password": this.password
            })
            .then(res=>{
                if(res.data.result == "ok"){
                    var homepage = null;
                    console.log(res.data.homepage)
                    if(res.data.homepage.length != 0)
                        homepage = res.data.homepage[0].route;
                    console.log(homepage)
                    this.$store.state.company = res.data.company;
                    localStorage.setItem('token', res.data.token);
                    localStorage.setItem('company', res.data.company)
                    this.$store.state.menu = res.data.menu;
                    this.$store.state.avatar = res.data.avatar;
                    this.$store.state.displayName = res.data.displayName;
                    axios.defaults.headers.common["Authorization"] = res.data.token;
                    
                    // Chiamata a URL_LOGIN per ottenere il ruolo dell'utente
                    axios.post(this.$store.state.URL_LOGIN, {
                        "user": this.username,
                        "password": this.password
                    })
                    .then(resLogin => {
                        // Salva il ruolo dell'utente nello store
                        if(resLogin.data && resLogin.data.roles){
                            this.$store.state.userRole = resLogin.data.roles;
                            localStorage.setItem('userRole', JSON.stringify(resLogin.data.roles));
                            console.log('User role from URL_LOGIN:', this.$store.state.userRole);
                        }
                    })
                    .catch(errorLogin => {
                        console.warn('Error loading user role from URL_LOGIN:', errorLogin);
                        // Imposta un ruolo di default in caso di errore
                        this.$store.state.userRole = '';
                    });
                    
                    // Rimuovi token v1 obsoleti prima di riautenticarsi con il nuovo utente
                    localStorage.removeItem('jwtToken');
                    localStorage.removeItem('userId');

                    // Chiamata alla nuova API v1 per ottenere il token JWT
                    axios.post(this.$store.state.BASE_URL + this.$store.state.URL_NEW_LOGIN_V1, {
                        "email": this.username,
                        "password": this.password
                    })
                    .then(resV1 => {
                        // Salva il token JWT restituito dalla v1
                        if(resV1.data && resV1.data.token){
                            localStorage.setItem('jwtToken', resV1.data.token);
                            console.log('JWT token from v1 saved');
                            // Timezone dalla risposta v1 se presente (es. user.userPreferences.timezone)
                            const v1User = resV1.data.user;
                            if (v1User && v1User.userPreferences && v1User.userPreferences.timezone) {
                                this.$store.state.timezone = this.normalizeTimezone(v1User.userPreferences.timezone);
                            }
                            // Ora chiamiamo /v1/users/me per ottenere le preferenze utente complete
                            return axios.get(this.$store.state.BASE_URL + this.$store.state.URL_GET_USER_PREFERENCES, {
                                headers: {
                                    'Authorization': `Bearer ${resV1.data.token}`
                                }
                            });
                        } else {
                            throw new Error('No JWT token received from login');
                        }
                    })
                    .then(userMeResponse => {
                        // Salva i dati completi dell'utente nello store dalla risposta di /v1/users/me
                        if(userMeResponse.data){
                            const userData = userMeResponse.data;
                            
                            this.$store.state.userId = userData.id || '';
                            this.$store.state.userEmail = userData.email || '';
                            this.$store.state.userName = userData.username || '';
                            this.$store.state.tenantId = userData.tenantId || '';
                            this.$store.state.userPreferences = userData.userPreferences || { selectedCharts: [] };
                            this.$store.state.permissions = userData.permissions || { allowedAreas: '' };
                            // Timezone da userPreferences (es. "europe/rome" -> "Europe/Rome")
                            const tz = userData.userPreferences && userData.userPreferences.timezone
                                ? this.normalizeTimezone(userData.userPreferences.timezone)
                                : 'Europe/Rome';
                            this.$store.state.timezone = tz;
                            // Salva userId in localStorage per il refresh JWT dopo F5
                            if (userData.id) {
                                localStorage.setItem('userId', userData.id);
                            }
                            
                            console.log('User data loaded from /v1/users/me:', userData);
                            console.log('User preferences with selectedCharts:', this.$store.state.userPreferences);
                        }
                    })
                    .catch(errorV1 => {
                        // Se la chiamata v1 fallisce, logga l'errore ma continua con il login
                        console.warn('Error loading user preferences (v1), continuing with login:', errorV1);
                        
                        // Imposta valori di default per le preferenze utente
                        this.$store.state.userPreferences = { selectedCharts: [] };
                        this.$store.state.timezone = 'Europe/Rome';
                        this.$store.state.permissions = { allowedAreas: '' };
                    })
                    .then(() => {
                        // Continua con il caricamento dei dati company in ogni caso
                        return axios.post(this.$store.state.URL_COMPANY_DATA,{
                            "Company" : this.$store.state.company
                        });
                    })
                    .then(res=>{
                        this.overlay = false;
                        this.$store.state.building = res.data
                        console.log(this.$store.state.building)
                        if(homepage != null)
                            this.$router.push({ path: homepage }); 
                        else{
                            if(this.$store.state.company == '1')
                                this.$router.push({ path: `/dashboards` }); 
                            else
                                this.$router.push({ path: `/welcome` });
                        }
                    })
                    .catch((error)=>{
                        console.error('Error during login process:', error);
                        this.overlay = false;
                        this.snackbar = true;
                    })
                }
                else{
                    this.overlay = false;
                    this.snackbar = true;
                }
            })
            .catch(() => {
                this.overlay = false;
                this.snackbar = true;
            });
        },
    }
}
</script>